module.exports = __webpack_public_path__ + "img/fail.5cf15af9.png";